
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  checkoutHeadline: {
    id: "CheckoutHeadline.checkout",
    defaultMessage: "Overview",
  },
  checkoutBackButton: {
    id: "CheckoutBackButton.checkout",
    defaultMessage: "Back to Configuration",
  },
  checkoutConfigurationHeadline: {
    id: "CheckoutConfigurationHeadline.checkout",
    defaultMessage: "Configured Washbasin",
  },
  checkoutPartsHeadline: {
    id: "CheckoutPartsHeadline.checkout",
    defaultMessage: "Assembly Parts",
  },
  checkoutPartsHeadlineLink: {
    id: "CheckoutPartsHeadlineLink.checkout",
    defaultMessage: "Configuration Overview",
  },
});

export default MESSAGES;